import { SET_KIOSK_SETTINGS } from '../types/kioskSettings'

const initState = {
  kioskSettings: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_KIOSK_SETTINGS:
      return {
        ...state,
        kioskSettings: action.payload.kioskSettings,
        lastModified: new Date().getTime(),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/kioskSettings.js